import { useQuery } from '@tanstack/react-query'
import { isNil } from 'lodash-es'
import { useParams } from 'next/navigation'
import { useCallback } from 'react'

import {
  contractQueries,
  TContractReceiptInformation,
} from '@/entities/contract'

type Props = {
  contractId?: number
}

export const useGuestReceiptInformation = ({
  contractId: contractIdProp,
}: Props = {}) => {
  const params = useParams()
  const contractId = (() => {
    if (contractIdProp) {
      return contractIdProp
    }

    return Number(params?.contractId)
  })()

  const { data, isError, error } = useQuery({
    ...contractQueries.guestReceiptInformation({ contractId }),
    enabled: false,
    meta: {
      useCustomHandling: true,
    },
  })

  const hasReceiptInformation = useCallback(
    (
      receiptInformation?: TContractReceiptInformation | null,
    ): receiptInformation is TContractReceiptInformation =>
      !isNil(receiptInformation) && !isNil(receiptInformation.receiptRequested),
    [],
  )

  return {
    hasReceiptInformation,
    receiptInformation: data,
    isError,
    error,
  }
}
